module.exports = __webpack_public_path__ + "static/media/Lens-Natural Shine_diameter.fb87a019.png";